import {h, Fragment} from "preact"
import Product from "./Product"
import ProductCard from "./ProductCard"
import { useAppStateSelector } from "@nosto/preact"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    return (
        <div class="grid product-grid search-product-grid grid--2-col-tablet-down grid--3-col-desktop" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <ProductCard className="grid__item" product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
